<admin-header [title]="title"></admin-header>
<!-- Search bar -->
<div class="menu-search-wrapper" style="padding: 10px 20px;">
	<input type="text" class="form-control menu-search" placeholder="Search menu items or categories..." [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()" />
</div>
<div class="row" *ngFor="let group of tilesGrouped" style="padding-top:10px">
	<h2 *ngIf="tilesGrouped.length > 1 && group[0].category !== 'Administration'" style="padding-left:30px; color:#344281">{{group[0].category}}</h2>
	<div class="card-grid">
		<div class="dashboard-card" *ngFor="let card of group" (click)="navigate(card.route)">
			<div class="icon-wrapper">
				<i [class]="card.icon"></i>
			</div>
			<div class="card-title">{{ card.text }}</div>
		</div>
	</div>
</div>